import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AccessTokenResponse } from '../login/objects/accessTokenResponse';
import { LoginRequest } from '../login/objects/loginRequest';
import { environment } from '../environments/environment';
import { ForgotpasswordRequest } from "../login/objects/forgotpasswordRequest";
import { ResetPasswordRequest } from "../login/objects/resetPasswordRequest";
import { Observable } from 'rxjs';
import { ClaimsResponse } from '../login/objects/claimsResponse';

@Injectable({
	providedIn: 'root'
})

export class LoginService {
	private readonly headers: HttpHeaders;
	private readonly apiUrl = environment.api;

	constructor(private http: HttpClient) {
		this.headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8' });
	}

	login(submitForm: LoginRequest) {
		return this.http.post<AccessTokenResponse>(`${this.apiUrl}Login/login`,  submitForm, {
			headers: this.headers
		});
	}

	forgotpassword(submitForm: ForgotpasswordRequest) {
		return this.http.post(`${this.apiUrl}Login/forgot`, submitForm, {
			headers: this.headers
		});
	}

	updatePassword(request: ResetPasswordRequest): Observable<any> {
		return this.http.post(`${this.apiUrl}Login/updatePassword`, request, {
			headers: this.headers
		});
	}

	getInfo(accessToken: string): Observable<ClaimsResponse> {
		const authHeaders = new HttpHeaders({
			'Content-Type': 'application/json; charset=utf-8',
			'Authorization': `Bearer ${accessToken}`
		});

		return this.http.get<ClaimsResponse>(`${this.apiUrl}Login/info`, {
			headers: authHeaders
		})
	}
}
